import { useTranslation } from "react-i18next";
import { FooterLink, type FooterLinkItem } from "./FooterLink";

export interface FooterColumnProps {
  title: string;
  links: readonly FooterLinkItem[];
}

/**
 * Una columna de enlaces del pie — "Tienda", "Cuenta y soporte".
 *
 * Es la MISMA columna para las dos: cambian el título y la lista, no la
 * forma. Tenerlas como dos bloques de JSX distintos era lo que hacía que
 * en el sistema actual una llevara `&` y la otra no.
 */
export function FooterColumn({ title, links }: FooterColumnProps) {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-ds-label font-bold uppercase tracking-ds-label text-ds-ink">
        {t(title)}
      </h3>
      <ul className="mt-4 grid gap-2.5">
        {links.map((link) => (
          <li key={`${link.to}-${link.label}`}>
            <FooterLink {...link} />
          </li>
        ))}
      </ul>
    </div>
  );
}
